import * as d3 from "d3";
import {colonAnnotation, createTooltip, numberFormat, responsivefy} from '../functions'

export default function (chart, divId, vizName,resData, filterParam) {
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName,filterParam);

    var renameKeys = function (obj) {
        /*Recursively renames "key" keys to "name" and
            renames "values" keys to "children" */
        obj.name = obj.key
        delete obj.key
        if (obj.values) {
            obj.children = obj.values
            delete obj.values
            obj.children.forEach(renameKeys)
        }
        return obj
    }

    // axios.post(url, filterParam).then(response => {
        let res = resData

        var data = d3.nest()
            .key((d) => {
                return d.dim1_name
            })
            .key((d) => {
                return d.dim2_name
            })
            .key((d) => {
                return d.dim3_name
            })
            .rollup((v) => {
                return d3.sum(v, (d) => {
                    return d.metric1
                })
            })
            .entries(res)

        /*The visualization requires there to be a root node*/
        var Data = {key: chart.y1AxisDisplayName, values: []}
        Data.values = data
        renameKeys(Data);

        (function visualize() {
            var transitioning

            var x1Scale = d3.scaleLinear().domain([0, chart.width]).range([0, chart.width])

            var y1Scale = d3.scaleLinear()
                .domain([0, chart.height - chart.margin.top - chart.margin.bottom])
                .range([0, chart.height - chart.margin.top - chart.margin.bottom])

            // var metric1ColorScale =d3.scaleSequential()
            //     .interpolator(d3['interpolate' + 'RdBu'])
            //     .domain([10000000,10000000000])

            // var metric1ColorScale =d3.scaleSequential()
            //     .interpolator(d3['interpolate' + 'RdBu'])
            //     .domain([d3.min(res,function(d) { return d.metric1}).d3.max(res,function(d){ return d.metric1})])
            // // .domain()


            var svg, grandparent

            updateDrillDown()

            function updateDrillDown() {
                if (svg) {
                    svg.selectAll('*').remove()
                } else {
                    svg = d3.select(divId).select("svg").remove();
                    svg = d3.select(divId).append('svg')
                        .attr('width', chart.width - chart.margin.left - chart.margin.right)
                        .attr('height', chart.height - chart.margin.bottom - chart.margin.top)
                        .style('margin-left', -chart.margin.left + 'px')
                        .style('margin.right', -chart.margin.right + 'px')
                        .call(responsivefy)
                        .append('g')
                        .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')
                        .style('shape-rendering', 'crispEdges')

                    grandparent = svg.append('g')

                    grandparent.append('rect')
                        .attr('y', -chart.margin.top)
                        .attr('width', chart.width)
                        .attr('height', chart.margin.top)
                        .attr('fill', 'orange')

                    grandparent.append('text')
                        .attr('x', 6)
                        .attr('y', 6 - chart.margin.top)
                        .attr('dy', '.75em')

                    var treemap = d3.treemap()
                        .tile(d3.treemapResquarify.ratio(chart.height / chart.width * 0.5 * (1 + Math.sqrt(5))))
                        .size([chart.width, chart.height])
                        .round(false)
                        .paddingInner(1)
                }

                var root = d3.hierarchy(Data)
                    .eachBefore(function (d) {
                        d.id = (d.parent ? d.parent.id + '.' : '') + d.data.name
                    })
                    .sum((d) => d.value)
                    .sort(function (a, b) {
                        return b.height - a.height || b.value - a.value
                    })

                initialize(root)
                accumulate(root)
                layout(root)
                treemap(root)
                display(root)
            }

            function initialize(root) {
                root.x = root.y = 0
                root.x1 = chart.width
                root.y1 = chart.height
                root.depth = 0
            }

            // Aggregate the values for internal nodes. This is normally done by the
            // treemap layout, but not here because of our custom implementation.
            // We also take a snapshot of the original children (_children) to avoid
            // the children being overwritten when when layout is computed.
            function accumulate(d) {
                d._children = d.children
                return (d._children) ? d.value = d.children.reduce(function (p, v) {
                    return p + accumulate(v)
                }, 0) : d.value
            }

            // Compute the treemap layout recursively such that each group of siblings
            // uses the same size (1×1) rather than the dimensions of the parent cell.
            // This optimizes the layout for the current zoom state. Note that a wrapper
            // object is created for the parent node for each group of siblings so that
            // the parent’s dimensions are not discarded as we recurse. Since each group
            // of sibling was laid out in 1×1, we must rescale to fit using absolute
            // coordinates. This lets us use a viewport to zoom.
            function layout(d) {
                if (d._children) {
                    d._children.forEach(function (c) {
                        c.x0 = d.x0 + c.x0 * d.x1
                        c.y0 = d.y0 + c.y0 * d.y1
                        c.x1 *= (d.x1 - d.x0)
                        c.y1 *= (d.y1 - d.y0)
                        c.parent = d
                        layout(c)
                    })
                }
            }

            function display(d) {
                grandparent
                    .datum(d.parent)
                    .on('click', transition)
                    .select('text')
                    .text(name(d))
                    .attr('fill', 'black')

                var g1 = svg.insert('g', '.grandparent').datum(d).attr('class', 'depth')
                var g = g1.selectAll('g').data(d._children).enter().append('g')

                /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
                     var tip = tooltip_class()

                     tip.attr('class', 'd3-tip'+divId.id)
                        .html((d) =>{
                                return d.data.name+ colonAnnotation + ' (' + numberFormat(d.value) + ')'
                        })

                     g.call(tip)*/


                // d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
                // var div = d3.select(divId).append('div').attr('class', 'tooltip')
                //     .attr('style', 'position: absolute; opacity: 0;')

                const tooltip = createTooltip(divId);


                var children = g.selectAll('.child')
                    .data(function (d) {
                        return d._children || [d]
                    })
                    .enter()
                    .append('g')
                    .on('mouseover', function( d) {
                        tooltip.onMouseOver(d, this, function(d) {
                            // Tooltip content callback
                            return d.data.name + colonAnnotation + ' (' + numberFormat(d.value) + ')'
                        });  // Pass the event for positioning
                    })
                    .on('mousemove', function(event) {
                        tooltip.onMouseMove(event);  // Update tooltip position on mouse move
                    })
                    .on('mouseout', function() {
                        tooltip.onMouseLeave();  // Hide the tooltip on mouse leave
                    });

                children.append('rect').attr("class", "child").call(rect)

                //     var metric1ColorScale =d3.scaleSequential()
                //         .interpolator(d3['interpolate' + 'Blues'])
                //         .domain([d3.min(d._children || [d],function(d) { return d.value}),
                // d3.max(d._children || [d],function(d) { return d.value})])

                var metric1ColorScale = d3.scaleLinear()
                    .range(["#eff3ff", "#3182bd"])
                    //  .interpolator(d3['interpolate' + 'Blues'])
                    .domain([d3.min(d._children || [d], function (d) {
                        return d.value
                    }),
                        d3.max(d._children || [d], function (d) {
                            return d.value
                        })])

                // console.log("minimum",d3.min(d._children || [d],function(d) { return d.value}))

                var c = children.append('text')
                    .attr('class', 'ctext')
                    .attr("dy", "-.15em")

                c.append("tspan")
                    .text(function (d) {
                        return d.data.name.length > 5 ? (d.data.name.substring(0, 5) + "..") : d.data.name
                    })

                c.append('tspan').attr("dy", ".60em").text(function (d) {
                    return numberFormat(d.value)
                })

                c.call(text2)

                g.append('rect')
                    .attr('class', 'parent')
                    .call(rect)
                    .on('mouseover', function( d) {
                        tooltip.onMouseOver(d, this, function(d) {
                            // Tooltip content callback
                            return d.data.name + colonAnnotation + ' (' + numberFormat(d.value) + ')'
                        });  // Pass the event for positioning
                    })
                    .on('mousemove', function(event) {
                        tooltip.onMouseMove(event);  // Update tooltip position on mouse move
                    })
                    .on('mouseout', function() {
                        tooltip.onMouseLeave();  // Hide the tooltip on mouse leave
                    });

                var t = g.append('text').attr('class', 'ptext').attr('dy', '.75em')

                t.append('tspan').attr("font-size", "12px").attr("font-color", "black")

                t.append('tspan')
                    .attr("font-size", "12px")
                    .text(function (d) {
                        return d.data.name.length > 5 ? (d.data.name.substring(0, 5) + "..") : d.data.name
                    })

                t.append('tspan')
                    .attr('dy', '1.0em')
                    .attr("font-size", "12px")
                    .text(function (d) {
                        return numberFormat(d.value)
                    })


                t.call(text)

                g.selectAll('rect')
                    .style('fill', (d) => {

                        return metric1ColorScale(d.value)
                    })
                    .on('mouseover', function( d) {
                        tooltip.onMouseOver(d, this, function(d) {
                            // Tooltip content callback
                            return d.data.name + colonAnnotation + ' (' + numberFormat(d.value) + ')'
                        });  // Pass the event for positioning
                    })
                    .on('mousemove', function(event) {
                        tooltip.onMouseMove(event);  // Update tooltip position on mouse move
                    })
                    .on('mouseout', function() {
                        tooltip.onMouseLeave();  // Hide the tooltip on mouse leave
                    });

                g.filter(function (d) {
                    return d._children
                })
                    .classed('children', true)
                    .on('click', transition)

                function transition(d) {
                    if (transitioning || !d) return
                    transitioning = true
                    var g2 = display(d),
                        t1 = g1.transition().duration(750),
                        t2 = g2.transition().duration(750)

                    // Update the domain only after entering new elements.
                    x1Scale.domain([d.x0, d.x0 + (d.x1 - d.x0)])
                    y1Scale.domain([d.y0, d.y0 + (d.y1 - d.y0)])

                    // Enable anti-aliasing during the transition.
                    svg.style('shape-rendering', null)

                    // Draw child nodes on top of parent nodes.
                    svg.selectAll('.depth').sort(function (a, b) {
                        return a.depth - b.depth
                    })


                    // Fade-in entering text.
                    g2.selectAll('text').style('fill-opacity', 0)

                    // Transition to the new view.
                    d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
                    t1.selectAll('.ptext').call(text).style('fill-opacity', 0)
                    t2.selectAll('.ptext').call(text).style('fill-opacity', 1)
                    t1.selectAll('.ctext').call(text2).style('fill-opacity', 0)
                    t2.selectAll('.ctext').call(text2).style('fill-opacity', 1)
                    t1.selectAll('rect').call(rect)
                    t2.selectAll('rect').call(rect)

                    // Remove the old node when the transition is finished.
                    t1.remove().on('end', function () {
                        svg.style('shape-rendering', 'crispEdges')
                        transitioning = false
                    })
                }

                return g
            }

            function text(text) {
                text.selectAll('tspan').attr('x', (d) => {
                    return x1Scale(d.x0) + 6
                })
                text.attr('x', (d) => {
                    return x1Scale(d.x0) + 6
                })
                    .attr('y', (d) => {
                        return y1Scale(d.y0) + 3
                    })
                    .style('opacity', function (d) {
                        var w = x1Scale(d.x1) - x1Scale(d.x0)
                        return this.getComputedTextLength() < w - 6 ? 1 : 0
                    })
            }

            function text2(text) {
                text.selectAll("tspan")
                    .attr("x", function (d) {
                        return x1Scale(d.x1) - 16;
                    })
                    .attr("x", function (d) {
                        return x1Scale(d.x1) - this.getComputedTextLength() - 5;
                    })
                    .attr("y", function (d) {
                        return y1Scale(d.y1) - 10;
                    })
                    //  .attr("display", function(d) { return  x(d.x1) - x(d.x0) >=  this.getComputedTextLength() ? "block" :"none" })
                    .style('opacity', function (d) {
                        var w = x1Scale(d.x1) - x1Scale(d.x0)
                        return this.getComputedTextLength() < w - 6 ? 1 : 0
                    })
            }

            function rect(rect) {
                rect.attr('x', (d) => {
                    return x1Scale(d.x0)
                })
                    .attr('y', (d) => {
                        return y1Scale(d.y0)
                    })
                    .attr('width', (d) => {
                        var w = x1Scale(d.x1) - x1Scale(d.x0)
                        return w
                    })
                    .attr('height', function (d) {
                        var h = y1Scale(d.y1) - y1Scale(d.y0)
                        return h
                    })
            }

            function name(d) {
                return d.parent ? name(d.parent) + ' / ' + d.data.name + ' (' + numberFormat(d.value) + ')' : d.data.name + ' (' + numberFormat(d.value) + ')'
            }
        })(Data)
        console.log("treemapChart", Data)
    // })
}
